<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    export let labelText = '';
    export let value = false;
    let input = (e) => {
      dispatch('input');
    };
  </script>

<input type="checkbox" class="sb-checkbox" on:input={input} bind:checked={value}/>

<style>
     .sb-checkbox {
    -webkit-appearance: none;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 2px;
    cursor: pointer;
    height: 18px;
    width: 18px;
    position: relative;
  }
  .sb-checkbox::after {
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    content: '';
    height: 5px;
    left: 3px;
    opacity: 0;
    position: absolute;
    top: 3px;
    transform: rotate(-45deg);
    width: 8px;
  }
  .sb-checkbox:checked {
    background-color: var(--h-c);
    border: 1px solid var(--h-c);
  }
  .sb-checkbox:checked::after {
    opacity: 1;
  }
</style>